<template>
  <div>
    <template v-if="ports !== null">
      <div class="row menubar">
        <input
          type=text ref="search" placeholder="Zoeken"
          @keyup="updateSearch" class="searchbar"
          style="width: 150px"
        >
        <button @click="ports = null;getAdminRisks()">
          <awesomeIcon icon="sync" />
        </button>
        <span>Maanden:</span>
        <input type=number v-model="dueMonths" class="searchbar" style="width: 150px">
        <button
          :class="{ 'disabled': dueMonths == '0' }"
          @click="dueMonths='0'"
          style="float:right;"
        >
          Alleen verlopen
        </button>
        <multiDropdown
          v-model="selectedBrands"
          :array="portBrands"
          displayPrefix="Merk"
          style="float:right"
        />
        <inputDropdown
          :array="portRisks"
          v-model="portRisk"
          style="float:right"
        />
        <inputDropdown
          :array="portManagers"
          v-model="portManager"
          :scroll="true"
          style="float:right"
        />
        <button style="float: right;" @click="download">
         Download ({{ports.length}})
        </button>
      </div>

      <div class="card">
        <div class="card-header chart-title">CDD over tijd</div>
        <div class="card-graph">
          <GChart
            :settings="{ packages: ['corechart'], language: 'nl-nl' }"
            :data="data"
            :options="options"
            :events="chartEvents"
            type="ComboChart"
          />
        </div>
      </div>

      <div class="card">
        <div class="scores">
          <span class="chart-bottom-text">
            Hoeveelheid hoog:
            {{
              formatPrice(filter(filter(brandPorts, searchFilter), {risk_level: 3}).length ,true)
            }}
          </span>
          <span class="chart-bottom-text">
            Hoeveelheid midden:
            {{
              formatPrice(filter(filter(brandPorts, searchFilter), {risk_level: 2}).length ,true)
            }}
          </span>
          <span class="chart-bottom-text">
            Hoeveelheid laag:
            {{
              formatPrice(filter(filter(brandPorts, searchFilter), { risk_level: 1 }).length,true)
            }}
          </span>
          <span class="chart-bottom-text">
            Hoeveelheid pending:
            {{
              formatPrice(filter(
                filter(brandPorts, searchFilter),
                (o) => o.intake_status,
              ).length, true)
            }}
          </span>
          <br />
          <span id="scores-tooltip" class="chart-bottom-text" />
        </div>
        <table width="100%">
          <thead class="table-legend">
            <tr>
              <th>#</th>
              <th>Merk</th>
              <th>Beheerder</th>
              <th>Status</th>
              <th>Risk</th>
              <th>Last CDD</th>
              <th>Last plan</th>
              <th>Next CDD</th>
              <th>Intake status</th>
              <th></th>
            </tr>
          </thead>
          <tr
            v-for="port in slice(
              computedPorts,
              currentPage * resultsPerPage,
              (currentPage + 1) * resultsPerPage
            )"
            :key="port.id"
          >
            <td width=50>{{port.id}}</td>
            <td>{{port.profile}}</td>
            <td class="concat100" :title="port.managerEmail">{{port.managerEmail}}</td>
            <td>{{toStatus(port.status)}}</td>
            <td>{{port.risk_level}}</td>
            <td style="white-space: no wrap;">
              {{(new Date(port.risk_date)).toLocaleDateString()}}
            </td>
            <td>
              {{ port.intake_date
                ? new Date(port.intake_date).toLocaleDateString()
                : '-'
              }}
            </td>
            <td :class="{ 'red': new Date() > port.next_date }">
              {{port.next_date.toLocaleDateString()}}
              <br>
              <span class="grey">{{port.firstMonth}} maand(en)</span>
            </td>
            <td>
              {{ port.intake_status ? port.intake_status : '-' }}
            </td>
            <td v-if="port.intake">
              <button @click="doOpen(port.intake)" class="secondary">
                <awesomeIcon icon="redo-alt"/> Vervolg intake {{port.intake}}
              </button>
            </td>
            <td v-else>
              <button
                @click="redoIntake(
                  port.id,
                )"
                class="secondary"
              >
                <awesomeIcon icon="clipboard-list"/> Open her-intake!
              </button>
            </td>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="filter(brandPorts, searchFilter).length"
          :resultsPerPage="resultsPerPage"
        />
      </div>
    </template>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  filter, slice, sortBy, includes, reject,
} from 'lodash-es';
import FileSaver from 'file-saver';

export default {
  name: 'RiskCalendar',
  data() {
    return {
      search: '',
      ports: null,
      users: [],
      portManager: 'Alle beheerders',
      currentPage: 0,
      resultsPerPage: 10,
      dueMonths: '24',
      chartType: 'BarChart',
      options: {
        height: 300,
        colors: JSON.parse(JSON.stringify(process.env.VUE_APP_STYLE === 'db' ? ['#6c0', '#006'] : this.$store.state.colorScheme)),
        legend: {
          position: 'none',
        },
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        tooltip: {
          trigger: 'none',
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Due month',
        },
        {
          type: 'number',
          label: 'Maanden',
        },
      ],
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
      selectedBrands: '',
      portBrands: [
        {
          value: 'Doelbeleggen',
          label: 'Doelbeleggen',
        },
        {
          value: 'OXBY',
          label: 'OXBY',
        },
        {
          value: 'VMVB',
          label: 'VMVB',
        },
        {
          value: 'BVS',
          label: 'BVS',
        },
      ],
      portRisk: 'Alle risico\'s',
      portRisks: [
        {
          value: 'Alle risico\'s',
        },
        {
          value: 'Laag',
        },
        {
          value: 'Midden',
        },
        {
          value: 'Hoog',
        },
      ],
    };
  },
  created() {
    this.getAdminRisks();
  },
  watch: {
    computedPorts() {
      this.currentPage = 0;
    },
  },
  computed: {
    computedPorts() {
      return filter(sortBy(this.brandPorts, 'next_date'), this.searchFilter);
    },
    brandPorts() {
      let arrayBrands = [];
      if (this.selectedBrands) {
        arrayBrands = this.selectedBrands.split(',');
      }
      let b = [...arrayBrands]; // Create clone to not change selectedBrands
      if (!Array.isArray(b)) {
        b = [];
      }
      if (b.length === 0) {
        for (let i = 0; i < this.portBrands.length; i += 1) {
          b.push(this.portBrands[i].value);
        }
      }
      let r = null;
      if (this.portRisk === 'Hoog') {
        r = { risk_level: 3 };
      } else if (this.portRisk === 'Midden') {
        r = { risk_level: 2 };
      } else if (this.portRisk === 'Laag') {
        r = { risk_level: 1 };
      }
      let m = { manager: Number(this.portManager) };
      if (this.portManager === 'Alle beheerders') {
        m = null;
      }
      if (this.portManager === 'Onbekend') {
        m = { manager: null };
      }
      return filter(
        filter(
          filter(this.ports, (obj) => includes(b, obj.profile)),
          r,
        ),
        m,
      );
    },
    rows() {
      const temp = [];
      for (let i = 0; i <= this.dueMonths; i += 1) {
        temp.push([`${i}`, filter(this.brandPorts, (o) => o.firstMonth === i || ((i - o.firstMonth) > 0 && (i - o.firstMonth) % o.interval === 0)).length]);
      }
      return temp;
    },
    data() {
      return [this.columns].concat(this.rows);
    },
    portManagers() {
      const accounts = filter(this.users, (v) => v.role > 7);
      const labels = [];
      labels.push({ label: 'Alle beheerders', value: 'Alle beheerders' });
      labels.push({ label: 'Onbekend', value: 'Onbekend' });

      for (let i = 0; i < accounts.length; i += 1) {
        labels.push({ label: `${accounts[i].name} [${accounts[i].id}]`, value: accounts[i].id.toString() });
      }

      return labels;
    },
  },
  methods: {
    filter,
    slice,
    download() {
      const lineArray = [];
      lineArray.push(Object.keys(this.ports[0]).join(';'));
      this.ports.forEach((infoArray) => {
        const values = Object.values(infoArray).map((o, index) => {
          if (Number(o) && index !== 0) {
            return String(Math.round(Number(o) * 100) / 100).replace('.', ',');
          }
          return o;
        });
        lineArray.push(values.join(';'));
      });
      const file = new File(
        [lineArray.join('\n')],
        `${(new Date()).getFullYear()}${(new Date()).getMonth() + 1 < 10 ? `0${(new Date()).getMonth() + 1}` : (new Date()).getMonth() + 1}${(new Date()).getDate() < 10 ? `0${(new Date()).getDate()}` : (new Date()).getDate()}-risks.csv`,
        { type: 'text/csv;charset=utf-8' },
      );
      FileSaver.saveAs(file);
    },
    doOpen(intake) {
      window.open(`?intake=${intake}`);
    },
    setTooltipContent(object) {
      const tooltip = document.getElementById('scores-tooltip');
      if (object !== null) {
        tooltip.style.display = 'inline-block';
        tooltip.innerHTML = `<b>Over ${this.rows[object.row][0] ? `${this.rows[object.row][0]} - ` : ''}${this.columns[object.column].label}</b>: ${this.formatPrice(this.rows[object.row][object.column], true)} CDDs moeten worden verwerkt`;
      } else {
        tooltip.style.display = 'none';
      }
    },
    updateSearch() {
      this.search = this.$refs.search.value.toLowerCase().trim();
    },
    searchFilter(obj) {
      const date = new Date();
      date.setMonth(date.getMonth() + Number(this.dueMonths));
      if (obj.next_date < date) {
        if (obj.id.toLowerCase().indexOf(this.search) > -1) {
          return true;
        }
      }
      return false;
    },
    redoIntake(port) {
      this.sdk.redoIntake(port, () => {
        this.getAdminRisks();
      });
    },
    toStatus(status) {
      if (status === 1) {
        return 'bevroren';
      }
      if (status === 2) {
        return 'gepauzeerd';
      }
      if (status === 3) {
        return 'gesloten';
      }
      return 'actief';
    },
    monthDiff(d1, d2) {
      let months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    getAdminRisks() {
      this.sdk.getUsersQuick((userResponse) => {
        if (userResponse.status === 200) {
          const userCache = {};
          for (let l = 0; l < userResponse.data.length; l += 1) {
            if (userResponse.data[l].role > 7) {
              userCache[userResponse.data[l].id] = userResponse.data[l].email;
            }
          }
          this.users = userResponse.data;
          this.sdk.getProfiles((profileResponse) => {
            if (profileResponse.status === 200) {
              const profileCache = {};
              for (let l = 0; l < profileResponse.data.length; l += 1) {
                profileCache[profileResponse.data[l].id] = profileResponse.data[l].brand;
              }
              const date = new Date();
              this.sdk.getAdminRisks((response) => {
                if (response.status === 200) {
                  for (let i = 0; i < response.data.length; i += 1) {
                    response.data[i].next_date = new Date(response.data[i].risk_date);
                    // Fix for buggy risk dates
                    if (!response.data[i].next_date.getTime()) {
                      response.data[i].next_date = new Date();
                      response.data[i].next_date.setMonth(
                        response.data[i].next_date.getMonth() - (5 * 12),
                      );
                    }
                    response.data[i].profile = profileCache[response.data[i].profile]
                      ? profileCache[response.data[i].profile]
                      : 'onbekend';
                    if (userCache[response.data[i].manager]) {
                      response.data[i].managerEmail = userCache[response.data[i].manager];
                    } else {
                      response.data[i].managerEmail = 'onbekend';
                      response.data[i].manager = null;
                    }
                    if (Number(response.data[i].risk_level) === 1) {
                      response.data[i].next_date.setMonth(
                        response.data[i].next_date.getMonth() + (5 * 12),
                      );
                      response.data[i].interval = 60;
                    } else if (Number(response.data[i].risk_level) === 2) {
                      response.data[i].next_date.setMonth(
                        response.data[i].next_date.getMonth() + (3 * 12),
                      );
                      response.data[i].interval = 36;
                    } else {
                      response.data[i].next_date.setMonth(
                        response.data[i].next_date.getMonth() + (1 * 12),
                      );
                      response.data[i].interval = 12;
                    }
                    let firstMonth = 0;
                    if (response.data[i].next_date > date) {
                      firstMonth = this.monthDiff(date, response.data[i].next_date);
                    }
                    response.data[i].firstMonth = firstMonth;
                    response.data[i].next_dateString = response.data[i].next_date.toISOString();
                  }
                  this.ports = reject(
                    response.data,
                    { status: 3 },
                  );
                  this.$nextTick(() => {
                    this.resultsPerPage = 25;
                  });
                } else {
                  this.sdk.logout();
                  window.location.reload();
                }
              });
            } else {
              this.sdk.logout();
              window.location.reload();
            }
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style scoped>
  .searchbar {
    width: 300px;
    float: left;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .secondary {
    padding: 0 10px;
    float: right;
  }
  .card-graph {
    padding-bottom: 10px;
    min-height: 300px;
  }
  .chart-title {
   padding: 20px 0 10px 30px;
   font-size: 20px;
  }
  .chart-bottom-text {
    padding: 0 0 20px 15px;
    display: inline-block;
  }
  .scores {
    padding-left: 28px;
  }
</style>
